export default __webpack_public_path__ + "8a39ea3023812d3176cec5e448b80c6d.png";